export const filterChipStyles = {
  borderRadius: '10px',

  '&[data-is-selected="true"]': {
    backgroundColor: ({ palette }) => `${palette.primary.soft} !important`,
  },
};
